document.addEventListener('DOMContentLoaded', function() {
    const prevButton = document.querySelector('.slider-button--prev');
    const nextButton = document.querySelector('.slider-button--next');
    const slider = document.querySelector('.slider');

    function moveSlider(direction) {
        const slides = slider.querySelectorAll('.slider__slide');
        const slideWidth = slides[0].offsetWidth;
        const currentScroll = slider.scrollLeft;

        if (direction === 'next') {
            slider.scrollLeft = currentScroll + slideWidth;
        } else if (direction === 'prev') {
            slider.scrollLeft = currentScroll - slideWidth;
        }
    }

    nextButton.addEventListener('click', function() {
        moveSlider('next');
    });

    prevButton.addEventListener('click', function() {
        moveSlider('prev');
    });

    document.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowRight') {
            moveSlider('next');
        } else if (e.key === 'ArrowLeft') {
            moveSlider('prev');
        }
    });
});